import React, { useEffect } from 'react';
import './rops2024.css';
import { rops2024 } from '../../json/rops2024';

const Rops2024 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Reglas de Operación 2024</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
             
              <div style={{ textAlign: 'left' }}>
                
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Atención_al_Migrante_2024_ene_31_alc7_05.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa de Atención al Migrante 2024</a></strong></h5>
                <p>
                <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/Reforma_ROP_Programa_de_Atención_al_Migrante_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reforma 02 de febrero de 2024</a><br />
                  </li>
                  </ul>
                </p>
                
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Atención_al_Pueblo_2024_ene_31_alc7_05.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa de Atención al Pueblo 2024</a></strong></h5>
                <p>
                <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/Reforma_ROP_Programa_Atención_al_Pueblo_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reforma 02 de febrero de 2024</a><br />
                  </li>
                  </ul>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Bienestar_de_Madres_Solteras_2024_ene_31_alc7_05.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Bienestar de Madres Solteras 2024</a></strong></h5>
                <p>
                <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/Reforma_ROP_Bienestar_de_Madres_Solteras_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reforma 02 de febrero de 2024</a><br />
                  </li>
                  </ul>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Bienestar_Desarrollo_2024_ene_31_alc7_05.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Apoyo Para el Bienestar y Desarrollo 2024</a></strong></h5>
                <p>
                <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/Reforma_ROP_Bienestar_y_Desarrollo_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reforma 02 de febrero de 2024</a><br />
                  </li>
                  </ul></p>
                
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Bienestar_Producción_2024_ene_31_alc7_05.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Pograma Bienestar y Producción 2024</a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Desarrollo_Inclusivo_2024_ene_31_alc7_05.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Desarrollo Inclusivo 2024</a></strong></h5>
                <p>
                <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/Reformas_ROP_Desarrollo_Inclusivo_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reforma 02 de febrero de 2024</a><br />
                  </li>
                  </ul>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Fom_Des_PSocial_2024_ene_31_alc7_05.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Fomento al Desarrollo de la Participación Social Para el Bienestar 2024</a></strong></h5>
                <p>
                <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/Reformas_ROP_Participacion_Social_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reforma 02 de febrero de 2024</a><br />
                  </li>
                  </ul>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Fomento_Artesanal_2024_ene_31_alc7_05.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Fomento Artesanal 2024</a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_IAAMEH_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Instituto para la Atención de las y los Adultos Mayores</a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Instituto_Hidalguense_de_la_Juventud.pdf"                '
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Instituto Hidalguense de la Juventud</a></strong></h5>
                <p>
                <ul>
                  <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/Reforma_ROP_Juventud_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reforma 02 de febrero de 2024</a><br />
                  </li>
                  </ul>
                </p>

              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Rops2024;